import { useMemo } from "react";
import { default as _Breadcrumbs } from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useRouter } from "next/router";
import { routesMapping } from "@/layouts/components/routesMapping";
import { Box } from "@mui/material";

export default function Breadcrumbs() {
    const router = useRouter();
    const { route, query } = router;

    const breadcrumbs = useMemo(() => {
        const breadcrumbsList = [{ label: "خانه", path: "/courses" }];

        for (let routesMappingKey in routesMapping) {
            if (route.startsWith(routesMappingKey)) {
                const routesMappingObject = routesMapping[routesMappingKey];
                breadcrumbsList.push({
                    label: routesMappingObject.label,
                    path: routesMappingObject.getPath(
                        ...routesMappingObject.queries.map(
                            (queryKey) => query[queryKey]
                        )
                    ),
                });
            }
        }

        return breadcrumbsList;
    }, [route, query]);

    return (
        <Box sx={{ padding: { xs: "14px 4px", sm: "18px 8px" } }}>
            <_Breadcrumbs aria-label="breadcrumb">
                {breadcrumbs.map((item, idx, arr) => {
                    const total = arr.length;
                    const theLastOne = idx === total - 1;

                    return (
                        <Link
                            key={idx}
                            component="button"
                            underline={theLastOne ? "none" : "hover"}
                            color={theLastOne ? "primary" : "gray"}
                            sx={{ hover: "pointer" }}
                            onClick={() => {
                                if (!theLastOne) router.push(item.path);
                            }}
                        >
                            {item.label}
                        </Link>
                    );
                })}
            </_Breadcrumbs>
        </Box>
    );
}
